/* ng build --configuration qastaging --base-href /kiosk/ */

export const environment = {
	production: false
};
